import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Suspense } from "react";

import { PageWrapper } from "~/components/page-wrapper";
import { TaxCategoriesList } from "~/components/settings/tax-categories-list";
import { Skeleton } from "~/components/ui/skeleton";

export const Route = createFileRoute("/_authenticated/settings/tax-categories")(
  {
    component: TaxCategoriesPage,
  }
);

function TaxCategoriesPage() {
  return (
    <PageWrapper
      description="Manage tax categories for your organization"
      title="Tax Categories"
    >
      <Suspense fallback={<Skeleton className="h-full w-full" />}>
        <TaxCategoriesList />
      </Suspense>
      {/* Outlet for child routes (e.g., /$categoryId/edit modal) */}
      <Outlet />
    </PageWrapper>
  );
}
